// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/images/dental-center.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Hero/Hero.css */
.hero {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  height: 600px;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(226, 246, 255, 0.4);
}

/* .hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
} */

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
  margin: 0 auto;
}

.hero h1 {
  font-size: 2.8rem;
  margin-top: 60px;
  margin-bottom: 20px;
  /* text-shadow: 0 2px 4px rgba(0,0,0,0.3); */
}

.hero p {
  font-size: 1.3rem;
  margin-bottom: 30px;
  /* text-shadow: 0 1px 2px rgba(0,0,0,0.3); */
}

.hero-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
}


/* Responsive Adjustments */
@media (max-width: 768px) {
  .hero {
    height: 500px;
  }
  
  .hero h1 {
    font-size: 2.2rem;
  }
  
  .hero p {
    font-size: 1.1rem;
  }
  
  .hero-buttons {
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 576px) {
  .hero {
    height: 450px;
  }
  
  .hero h1 {
    font-size: 1.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/hero/hero.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,yDAAgE;EAChE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;;;;;;;;GAQG;;AAEH;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;;AAGA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* src/components/Hero/Hero.css */\n.hero {\n  background-image: url('/public/assets/images/dental-center.png');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  position: relative;\n  height: 600px;\n}\n\n.hero-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(226, 246, 255, 0.4);\n}\n\n/* .hero::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.3);\n} */\n\n.hero-content {\n  position: relative;\n  z-index: 2;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.hero h1 {\n  font-size: 2.8rem;\n  margin-top: 60px;\n  margin-bottom: 20px;\n  /* text-shadow: 0 2px 4px rgba(0,0,0,0.3); */\n}\n\n.hero p {\n  font-size: 1.3rem;\n  margin-bottom: 30px;\n  /* text-shadow: 0 1px 2px rgba(0,0,0,0.3); */\n}\n\n.hero-buttons {\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n}\n\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .hero {\n    height: 500px;\n  }\n  \n  .hero h1 {\n    font-size: 2.2rem;\n  }\n  \n  .hero p {\n    font-size: 1.1rem;\n  }\n  \n  .hero-buttons {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n@media (max-width: 576px) {\n  .hero {\n    height: 450px;\n  }\n  \n  .hero h1 {\n    font-size: 1.8rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
